export default __webpack_public_path__ + "static/media/img-news-1.76fd5a2e.png";